import HCaptcha from "@hcaptcha/react-hcaptcha"
import { Link, navigate } from "gatsby"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { useDropzone } from "react-dropzone"
import { Controller, useForm } from "react-hook-form"
import { site } from "../../../../../utils/site.js"
import Button from "../button/Button.js"
import Card from "../card/Card.js"
import Icon from "../icon/Icon.js"
import Image from "../image/Image.js"
import * as classNames from "./CandidatureForm.module.scss"

const CandidatureForm = ({
  title,
  subTitle,
  closeTo,
  buttonText = "Valider la demande de devis",
  confirmationText = "Votre demande de devis a bien été effectuée.",
  location,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm()


  const [activeStep, setActiveStep] = useState(2)
  const [fileError] = useState("")
  const [fileSubmitionError, setFileSubmitionError] = useState("")
  const [prenom, setPrenom] = useState("")
  const [captchaError, setCaptchaError] = useState("")
  const [token, setToken] = useState(null)
  const [loading, setLoading] = useState(false)
  const captchaRef = useRef(null)

  const onLoad = () => {
    // captchaRef.current.execute()
  }

  useEffect(() => {
    if (token) {
      setCaptchaError("")
    } else {
      setCaptchaError("Veuillez valider le captcha")
    }
  }, [token])

  const onSubmit = async (data, e) => {
    e.preventDefault()
    try {
      if (token !== null) {
        setCaptchaError("")
        setLoading(true)
        console.log("onSubmit", data)
        setPrenom(data.prenom)
        const urlParams = new URLSearchParams(window.location.search)

        for (const [key, value] of urlParams.entries()) {
          data[key] = value
        }

        data.site = site

        console.log("data", data)

        if (data.cv?.length > 0) {
          setFileSubmitionError("")
          const formData = new FormData()
          for (const file of data.cv) {
            formData.append("cv", file)
          }
          // other form data
          for (const [key, value] of Object.entries(data)) {
            if (key !== "cv") {
              formData.append(key, value)
            }
          }

          try {
            await fetch(
              process.env.GATSBY_NEST_BASE_URL + "/contact-form/candidature",
              {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                body: formData,
              }
            )
            setLoading(false)
            setActiveStep(4)
          } catch (error) {
            console.error("Erreur post Nest:" + error.message, error)
            setLoading(false)
          }
        } else {
          setFileSubmitionError("Veuillez ajouter un CV.")
        }
      } else {
        setCaptchaError("Veuillez valider le captcha")
      }
    } catch (error) {
      console.log(error)
    }
  }

  const maxSizeBytes = 10485760 // 10MB in bytes
  const maxSizeMB = maxSizeBytes / (1024 * 1024) // Convert bytes to megabytes
  const acceptedFormats = [".pdf", ".doc", ".docx"] // PDF, Word formats

  const [acceptedFiles, setAcceptedFiles] = useState([])
  const [errorMessage, setErrorMessage] = useState("")

  const removeFile = (index) => {
    const filteredFiles = acceptedFiles.filter((file, i) => i !== index)
    setAcceptedFiles(filteredFiles)
  }

  useEffect(() => {
    setValue("cv", acceptedFiles)
  }, [acceptedFiles, setValue])

  const handleFileChange = (e) => {
    const files = e.target.files
    const invalidFiles = Array.from(files).filter(
      (file) =>
        !acceptedFormats.includes(
          file.name.slice(file.name.lastIndexOf("."))
        ) || file.size > maxSizeBytes
    )

    if (invalidFiles.length > 0) {
      const invalidFileNames = invalidFiles.map((file) => file.name).join(", ")
      setErrorMessage(`Les fichiers doivent être en format PDF ou Word.`)
    } else {
      setErrorMessage("") // Clear any previous error message
      const validFiles = Array.from(files).filter(
        (file) =>
          acceptedFormats.includes(
            file.name.slice(file.name.lastIndexOf("."))
          ) && file.size <= maxSizeBytes
      )

      setAcceptedFiles((prevFiles) => [...prevFiles, ...validFiles])
    }
  }

  const onDrop = useCallback(
    (files) => {
      const newFiles = files.filter(
        (file) =>
          acceptedFormats.includes(
            file.name.slice(file.name.lastIndexOf("."))
          ) && file.size <= maxSizeBytes
      )
      setAcceptedFiles((prevFiles) => [...prevFiles, ...newFiles])

      const rejectedFiles = files.filter(
        (file) =>
          !acceptedFormats.includes(
            file.name.slice(file.name.lastIndexOf("."))
          ) || file.size > maxSizeBytes
      )

      if (rejectedFiles.length > 0) {
        const rejectedFileNames = rejectedFiles
          .map((file) => file.name)
          .join(", ")
        if (rejectedFiles.some((file) => file.size > maxSizeBytes)) {
          setErrorMessage(
            `<strong>Attention la taille du fichier dépasse le poids maximum autorisé (${maxSizeMB} MB).</strong> La taille des fichiers ne doit pas dépasser plus de 10 MB par fichier.`
          )
        } else {
          setErrorMessage(`Les fichiers doivent être en format PDF ou Word.`)
        }
      } else {
        setErrorMessage("")
      }
    },
    [acceptedFormats, maxSizeBytes, maxSizeMB]
  )

  const { getRootProps, getInputProps, isDragActive, isDragReject, open } =
    useDropzone({
      onDrop,
      accept: acceptedFormats.join(","),
      maxSize: maxSizeBytes,
      multiple: true,
      noClick: true, // Disable click events for the dropzone
    })

  function stepTitleBar(title, subTitle) {
    return (
      <>
        <h1
          className="text-center relative"
          style={{ color: "rgb(255, 255, 255)" }}
        >
          {title}
        </h1>
        <p
          className="text-center relative"
          style={{
            marginTop: "8px",
            paddingBottom: "40px",
            color: "rgb(255, 255, 255)",
          }}
        >
          {subTitle}
        </p>
      </>
    )
  }
  const filesArray = Array.from(acceptedFiles)

  const step2 = (
    <div className="step-2">
      {stepTitleBar(title)}
      <Card className="p-3 text-center mb-3">
        <p>{subTitle}</p>
        <div className="buttons mt-3 justify-content-center gap-3">
          <Button
            aspect="classique"
            size="large"
            color="primary"
            onClick={() => {
              setActiveStep(3)
            }}
          >
            <Icon
              icon="facture"
              color="primary"
            />
            Joindre mon CV et une lettre de motivation
          </Button>
        </div>
      </Card>
      <div className="card p-3 flex flex-direction-column gap-3">
        <div className="form-group row gap-3">
          <div className="form-control col">
            <label htmlFor="nom">
              Nom<sup>*</sup>
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              placeholder="Nom"
              required="true"
              {...register("nom")}
            />
          </div>
          <div className="form-control col">
            <label htmlFor="prenom">
              Prénom<sup>*</sup>
            </label>
            <input
              type="text"
              id="prenom"
              name="prenom"
              placeholder="Prénom"
              required="true"
              {...register("prenom")}
            />
          </div>
        </div>
        <div className="form-group row gap-3">
          <div className="form-control col">
            <label htmlFor="email">
              Mail<sup>*</sup>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="votre.mail@mail.fr"
              pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
              autoComplete="username"
              required="true"
              {...register("email")}
            />
          </div>
          <div className="form-control col">
            <label htmlFor="phone">
              Téléphone<sup>*</sup>
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="06 10 20 30 40 "
              pattern="[0-9]{10}"
              required="true"
              {...register("phone")}
            />
          </div>
        </div>
        <div className="form-group">
          <div className={classNames.selectFiles}>
            <Button
              onClick={() => setActiveStep(3)}
              type="button"
              className={"fs-16"}
            >
              <Icon
                icon={"plus"}
                width={"15px"}
                height={"15px"}
              ></Icon>
              Importer mon CV et lettre de motivation
            </Button>
            {filesArray.map((file, index) => (
              <>
                <div className={classNames.uploadedSelectFiles}>
                  <Icon icon={"chain"}></Icon>
                  <p key={file.name}>
                    <Link
                      href={URL.createObjectURL(file)}
                      target="_blank"
                    >
                      {file.name}
                    </Link>
                  </p>
                  <div className={classNames.removeFileBtn}>
                    <Button
                      type="button"
                      onClick={() => removeFile(index)}
                    >
                      <Icon
                        onClick={() => removeFile(index)}
                        icon="cross"
                        className={classNames.icon}
                        width="16"
                        height="15"
                        color={"rgba(137, 137, 137, 1)"}
                      />
                    </Button>
                  </div>
                </div>
              </>
            ))}
            {fileSubmitionError !== "" && (
              <p style={{ color: "red" }}>{fileSubmitionError}</p>
            )}
          </div>
        </div>
      </div>
      <div className={`${classNames.captcha} pt-3`}>
        <div className={"flex flex-direction-column"}>
          <HCaptcha
            sitekey="43b3c312-284e-4979-83d5-41179dab6a83"
            onLoad={onLoad}
            onVerify={setToken}
            ref={captchaRef}
          />
          {captchaError && <p style={{ color: "red" }}>{captchaError}</p>}
        </div>

        <div>* Informations obligatoires</div>
      </div>

      <div className="form-control mt-4">
        <button
          className="submitButton primary contrastant fluid"
          type="submit"
          disabled={loading}
        >
          {buttonText}
        </button>
      </div>
    </div>
  )

  const step4 = (
    <div className="step-3 ">
      {stepTitleBar(title)}
      <div className="card p-6 text-center">
        <>
          <p
            className="fs-32"
            style={{ marginTop: "32px" }}
          >
            {/* {confirmationText} */}
            Merci d’avoir postulé {prenom} !
          </p>
          <p
            className="fs-16"
            style={{ marginTop: "24px" }}
          >
            Votre candidature a bien été enregistrée !<br />
            <br />
            Notre service recrutement reviendra rapidement vers vous.
            <br /> En attendant de peut-être pouvoir nous rencontrer, n’hésitez
            pas à consulter les pages de notre site pour devenir incollable sur
            Paritel.
          </p>
          <Link
            className="fs-20 flex align-center justify-center gap-1"
            style={{ marginTop: "32px" }}
            to="/travailler-chez-paritel/"
          >
            <Icon icon="arrowRight"></Icon>
            Découvrir l’ambiance de travail chez paritel
          </Link>

          {location && location.state?.agence && (
            <Link
              className="fs-20 flex align-center justify-center gap-1"
              style={{ marginTop: "32px" }}
              to={`/agences/${location?.state?.slug}`}
            >
              <Icon icon="arrowRight"></Icon>
              Découvrir {location?.state?.agence}
            </Link>
          )}
        </>
      </div>
    </div>
  )

  const step3 = (
    <div className="step-4">
      {stepTitleBar(title, subTitle)}
      <Card className={`p-3 text-center mb-3`}>
        <div
          className={`${classNames.filesCard}`}
          {...getRootProps()}
          style={{
            backgroundColor: isDragActive && !isDragReject ? "#EAF7FC" : "",
          }}
        >
          <Icon
            icon={isDragActive && !isDragReject ? "uploadingFiles" : "files"}
          ></Icon>
          <input {...getInputProps()} />
          {isDragActive && !isDragReject && (
            <>
              <p>
                <strong>Glisser-déposer </strong>
                <strong className="secondary-text-color">vos documents</strong>
                <br />
                <br />
                Type de fichiers acceptés PDF, Word (max 10Mb par fichier)
              </p>
            </>
          )}
          {!isDragActive && (
            <p>
              <strong>Glisser-déposer </strong>
              <strong className="secondary-text-color">vos documents</strong>
              <br />
              <br />
              Type de fichiers acceptés PDF, Word (max 10Mb par fichier)
            </p>
          )}
          {!isDragActive && (
            <div className="buttons mt-3 justify-content-center gap-3">
              <Controller
                control={control}
                name="cv"
                rules={{ required: "Veuillez ajouter un CV" }}
                render={({ field: { value = [], onChange, ...field } }) => {
                  return (
                    <>
                      <input
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        multiple
                        id="cv"
                        required
                      />
                      <Button
                        aspect="contrastant"
                        color="primary"
                        size="large"
                        onClick={() =>
                          document.querySelector("input[id='cv']").click()
                        }
                        type="button"
                      >
                        Parcourir vos fichiers
                      </Button>
                    </>
                  )
                }}
              />
              {fileError !== "" && <p style={{ color: "red" }}>{fileError}</p>}
            </div>
          )}
        </div>
      </Card>

      {acceptedFiles && acceptedFiles.length > 0 && (
        <div className={`${classNames.fileslist} mt-3`}>
          <p>Fichiers</p>
          <ul>
            {filesArray.map((file, index) => (
              <>
                <div className={classNames.uploadedfile}>
                  <Icon icon={"success"}></Icon>
                  <li key={file.name}>
                    <strong>{file.name}</strong>
                    <p
                      style={{
                        color: "rgba(137, 137, 137, 1)",
                        fontSize: "14px",
                      }}
                    >
                      {(file.size / (1024 * 1024)).toFixed(2)} MB
                    </p>
                  </li>
                  <div className={classNames.removeFileBtn}>
                    <Button
                      type="button"
                      onClick={() => removeFile(index)}
                    >
                      <Icon
                        onClick={() => removeFile(index)}
                        icon="cross"
                        className={classNames.icon}
                        width="16"
                        height="15"
                        color={"rgba(137, 137, 137, 1)"}
                      />
                    </Button>
                  </div>
                </div>
              </>
            ))}
          </ul>
        </div>
      )}
      {errorMessage && (
        <div className={`p-3 text-center mb-3 ${classNames.dragerror}`}>
          {errorMessage && (
            <>
              <div className={classNames.erroricon}>
                <Icon icon={"error"}></Icon>
              </div>
              <div className={classNames.errormeesage}>
                <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
              </div>
            </>
          )}
        </div>
      )}
      <div className={classNames.uploadedfileFinishBtn}>
        <Button
          aspect="contrastant"
          color="primary"
          size="large"
          type="button"
          className="fluid"
          disabled={acceptedFiles.length === 0}
          onClick={() => {
            setActiveStep(2)
            setFileSubmitionError("")
          }}
        >
          Suivant
        </Button>
      </div>
    </div>
  )

  let stepContent
  switch (activeStep) {
    case 2:
      stepContent = step2
      break
    case 3:
      stepContent = step3
      break
    case 4:
      stepContent = step4
      break
    default:
      console.log("invalide step " + activeStep)
      break
  }

  const contactForm = (
    <form
      className={`formulaire relative ${classNames.MeetingContactForm}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      {stepContent}
    </form>
  )

  return (
    <div className="relative">
      <Button
        aspect="unstyled"
        className={classNames.closeButton}
        onClick={() => {
          navigate(closeTo)
        }}
      >
        <Icon
          icon="cross"
          className={classNames.icon}
          width="16"
          height="15"
        />
      </Button>
      <div
        className="row"
        style={{ maxWidth: "900px" }}
      >
        <div
          className="column full p-4"
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat relative",
          }}
        >
          <Image
            imgSrc="https://media.paritel.fr/paritel-www-dev/assets/popin_bg_13c29dd2da.svg"
            imgAlt=""
            style={{
              position: "absolute",
              inset: "0px",
              width: "100%",
              height: "auto",
            }}
          />

          {contactForm}
        </div>
      </div>
    </div>
  )
}

export default CandidatureForm
